import { render, staticRenderFns } from "./EffectGeneration.vue?vue&type=template&id=4c8de370&"
import script from "./EffectGeneration.vue?vue&type=script&lang=js&"
export * from "./EffectGeneration.vue?vue&type=script&lang=js&"
import style0 from "./EffectGeneration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports